import { useQuery } from '@tanstack/react-query';
import { screeningClearanceRuleApi } from '../../../apis';
import { InternalApiEntityType, InternalApiScreeningClearanceRule } from '../../../api-internal';

const PAGE_SIZE = 50;

export const useQueryClearanceRules = (entityType: InternalApiEntityType) =>
  useQuery({
    queryKey: ['clearanceRules', entityType],
    queryFn: async () => {
      const rules: InternalApiScreeningClearanceRule[] = [];
      let page = 0;
      let total = Infinity;
      while (rules.length < total) {
        const result = await screeningClearanceRuleApi.findAll({ page, size: PAGE_SIZE, entityType });
        total = result.total;
        if (result.content.length === 0) {
          break;
        }
        rules.push(...result.content);
        page += 1;
      }
      return rules;
    },
  });
